import { Candidate } from "./Candidate";

export type ProjectStatus = 'draft' | 'active' | 'paused' | 'closed' | 'archived';
export type JobType = 'full_time' | 'part_time' | 'contract' | 'freelance' | 'internship';
export type WorkMode = 'remote' | 'on_site' | 'hybrid';
export type Visibility = 'public' | 'private' | 'company_only';
export type SalaryPeriod = 'hourly' | 'daily' | 'weekly' | 'monthly' | 'yearly';
export type WeekDay = 'monday' | 'tuesday' | 'wednesday' | 'thursday' | 'friday' | 'saturday' | 'sunday';
export type QuestionType = 'text' | 'textarea' | 'select' | 'multiselect' | 'checkbox' | 'radio';

export interface CustomQuestion {
  question: string;
  question_type: QuestionType;
  options?: string[];
  required: boolean;
}

export interface AssessmentCriteria {
  title: string;
  priority: number;
  description?: string;
}

export interface WorkSchedule {
  start_time?: string;
  end_time?: string;
  timezone?: string;
  days?: WeekDay[];
}

export interface Project {
  _id: string;
  company: string;
  project_name: string;
  description?: string;
  location?: string;
  job_type: JobType;
  work_mode: WorkMode;
  experience: {
    min: number;
    max: number;
  };
  salary?: {
    min?: number;
    max?: number;
    currency: string;
    period: SalaryPeriod;
    is_displayed: boolean;
  };
  screening_interview_type: 'on_call' | 'on_website' | 'both';
  work_schedule?: WorkSchedule;
  notice_period?: string;
  must_have_skills: string[];
  good_to_have_skills: string[];
  key_responsibilities: string[];
  why_join_us: string[];
  qualifications: string[];
  other_requirements?: string;
  assessment_criteria: AssessmentCriteria[];
  application_deadline?: string;
  start_date?: string;
  end_date?: string;
  status: ProjectStatus;
  visibility: Visibility;
  application_form_fields?: {
    resume?: { required: boolean };
    cover_letter?: { required: boolean };
    custom_questions?: CustomQuestion[];
  };
  created_by?: string;
  updated_by?: string;
  createdAt: string;
  updatedAt: string;
  
  // Additional frontend properties
  applicationCount?: number;
  candidates?: Candidate[];
}

export const projectStatusColors: any = {
  active: '#10b981', // green
  paused: '#f59e0b', // amber
  draft: '#6366f1', // indigo
  closed: '#ef4444', // red
  archived: '#6b7280', // gray
};